// extracted by mini-css-extract-plugin
module.exports = {"legend":"legend_legend__86Iwx","heading":"legend_heading__qOLnf","sublegend":"legend_sublegend__l7icO"};